import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAiControl as getAiControlService,
  sendMessage as sendMessageService,
  getMessages as getMessagesService,
} from "./tozy.service";
import {
  AiControlResponse,
  SendMessageRequest,
  SendMessageResponse,
  GetMessagesRequest,
  GetMessagesResponse,
} from "./tozy.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getAiControl = createAsyncThunk<
  AiControlResponse,
  void,
  { rejectValue: string }
>("tozy/getAiControl", async (_, { rejectWithValue }) => {
  try {
    return await getAiControlService();
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const sendMessage = createAsyncThunk<
  SendMessageResponse,
  SendMessageRequest,
  { rejectValue: string }
>("tozy/sendMessage", async (data, { rejectWithValue }) => {
  try {
    return await sendMessageService(data);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getMessages = createAsyncThunk<
  GetMessagesResponse,
  GetMessagesRequest | undefined,
  { rejectValue: string }
>("tozy/getMessages", async (params, { rejectWithValue }) => {
  try {
    return await getMessagesService(params);
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

